import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from '../../services/utilities/utilities.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { DonationService } from '../../services/donation/donation.service';
import { FileService } from '../../services/file/file.service';
import { DonationFromStatusTypeEnum } from '../../enum/donation-from-status-type.enum';
@Component({
  selector: 'app-proceed-to-payment',
  templateUrl: './proceed-to-payment.component.html',
  styleUrl: './proceed-to-payment.component.scss',
})
export class ProceedToPaymentComponent implements OnInit {
  public pledgeBody: any;
  public receiptFile: any;
  public receiptName: string;

  private queryParams: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly fileService: FileService,
    private readonly donationService: DonationService,
    private readonly utilitiesService: UtilitiesService,
    private readonly localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const encryptedString = params['data'];
      const decryptedParams =
        this.localStorageService.decryptObjectUrl(encryptedString);

      this.queryParams =
        this.localStorageService.encryptObjectUrl(decryptedParams);

      decryptedParams['campaign_id'] = decryptedParams?.id;
      delete decryptedParams['id'];

      this.pledgeBody = this.localStorageService.getLocalStorage(
        'donation_payment_data'
      );
      this.pledgeBody = this.localStorageService.decryptObjectUrl(
        this.pledgeBody
      );

      if (decryptedParams && this.pledgeBody) {
        this.pledgeBody.donation_from = DonationFromStatusTypeEnum.DONATION;
      }
    });
  }

  public uploadedFile: any[] = [];
  public uploadUrl = ''; // Replace with your actual upload URL

  public async submit() {
    const { isValid } = ValidationEngine.validateGroup('validationGrp');
    if (isValid) {
      const response = await this.utilitiesService.showSwalAndReturn({
        type: 'warning',
        title: 'Are you sure?',
        message: 'You want to submit your donation?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      });

      if (response.isConfirmed) {
        this.fileService
          .uploadSingleFile(this.receiptFile)
          .subscribe((result: any) => {
            this.pledgeBody.payment_receipt = JSON.stringify(result[0]);
            this.submitPledge();
          });
      }
    }
  }

  public async submitPledge() {
    if (this.pledgeBody?.isElasticId) {
      this.donationService.directNgoPledge(this.pledgeBody).subscribe({
        next: async (res) => {
          // type: 'success',
          const response = await this.utilitiesService.showSwalAndReturn({
            title: 'Your donation is currently being reviewed.',
            message:
              'Our team will verify the transaction and notify you once your donation is confirmed. You will receive an email with your receipt once the process is completed.',
            confirmButtonText: 'Back to List',
            showCancelButton: false,
            imageUrl: 'assets/images/icon/right_sign_round_arrow.svg',
            confirmButtonColor: '#FFD602',
          });

          if (response.isConfirmed) {
            this.localStorageService.clearLocalStorageByKey(
              'donation_payment_data'
            );
            this.router.navigate(['/find-ngo']);
          }
        },
      });
    } else {
      this.donationService.pledgeDonation(this.pledgeBody).subscribe({
        next: async (res) => {
          // type: 'success',
          const response = await this.utilitiesService.showSwalAndReturn({
            title: 'Your donation is currently being reviewed.',
            message:
              'Our team will verify the transaction and notify you once your donation is confirmed. You will receive an email with your receipt once the process is completed.',
            confirmButtonText: 'Back to Campaign',
            showCancelButton: false,
            imageUrl: 'assets/images/icon/right_sign_round_arrow.svg',
            confirmButtonColor: '#FFD602',
          });

          if (response.isConfirmed) {
            this.localStorageService.clearLocalStorageByKey(
              'donation_payment_data'
            );
            this.router.navigate(['/campaign'], {
              queryParams: { data: this.queryParams },
            });
          }
        },
      });
    }
  }

  public onFileChange(e: any): void {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.receiptFile = input.files[0];
      this, (this.receiptName = input.files[0].name);
    }
  }

  public triggerFileInput(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement;
    if (input) {
      input.click();
    }
  }

  //drag-and-drop-files
  public onDropSuccess(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files.length > 0) {
      this.onFileChange({ event: { target: { files: files } } });
    }
  }

  public onDragOver(event: DragEvent) {
    event.preventDefault();
    const items = event.dataTransfer?.items;
    if (items) {
      event.dataTransfer.dropEffect = 'copy';
    }
  }

  public goBack(): void {
    this.router.navigate(['/donate-to-campaign'], {
      queryParams: { data: this.queryParams },
    });
  }
}
